import { render } from "./dimension_glass.vue?vue&type=template&id=49dcab45"
import script from "./dimension_glass.vue?vue&type=script&lang=js"
export * from "./dimension_glass.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/loewe-zaun-live-56lid4vr.on-forge.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__